export function getMockUrl(url: string) {
    const origin = window.origin.includes('dev.premicorr.net')
        ? 'dev-api.premicorr.net/api'
        : window.origin.includes('demo.premicorr.net')
            ? 'demo-api.premicorr.net/api'
            : 'demo-api.premicorr.net/api';

    return `https://${origin}${url}`;
}
